<div class="error-message">
  <span [innerHTML]="data?.message"></span>
</div>
<div class="mt-2">
  <mat-dialog-actions align="end">
    <button mat-dialog-close class="primary-btn float-left">{{'global.close' | translate}}</button>
  </mat-dialog-actions>
</div>
